import { LazyAction, LazyModule } from 'owa-bundling-light';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailBodyCompression"*/ './lazyIndex'),
    {
        name: 'MailBodyCompression',
    }
);

export const lazyReportConversationCacheEviction: LazyAction<
    typeof lazyIndex.reportConversationCacheEviction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.reportConversationCacheEviction);

export const lazyReportMessageCacheEviction: LazyAction<
    typeof lazyIndex.reportMessageCacheEviction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.reportMessageCacheEviction);

export const lazyDecompressConversationBodies: LazyAction<
    typeof lazyIndex.decompressConversationBodies,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.decompressConversationBodies);

export const lazyDecompressMessageBodies: LazyAction<
    typeof lazyIndex.decompressMessageBodies,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.decompressMessageBodies);

export const lazyCompressConversation: LazyAction<
    typeof lazyIndex.compressConversation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.compressConversation);

export const lazyCompressMessage: LazyAction<typeof lazyIndex.compressMessage, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.compressMessage);
